import { Observable, shareReplay, tap } from 'rxjs';

/**
 * Reuses a single in-flight HTTP observable for the same key so brief route
 * remounts (e.g. refresh) do not cancel and restart identical GETs.
 */
export function shareInflightRequest<T>(
  inflight: Map<string, Observable<T>>,
  key: string,
  factory: () => Observable<T>
): Observable<T> {
  const existing = inflight.get(key);
  if (existing) {
    return existing;
  }

  const shared = factory().pipe(
    tap({
      complete: () => inflight.delete(key),
      error: () => inflight.delete(key),
    }),
    shareReplay({ bufferSize: 1, refCount: false })
  );
  inflight.set(key, shared);
  return shared;
}
